import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReceivedPoll } from 'src/app/models/ReceivedPoll';
import { Common } from 'src/app/shared/common';

@Component({
    selector: 'app-cse-header',
    templateUrl: 'cse-header.component.html',
    styleUrls: ['./cse-header.component.less', '../../shared/common.less']
})

export class CseHeaderComponent implements OnInit {
    @Input() pollData: ReceivedPoll;
    @Input() startDate = '';
    @Input() endDate = '';
    @Input() assessorsValidated: boolean;
    @Input() assessorCount: number = 0;
    @Input() inactiveAssessors: number = 0;
    @Input() canResendAssessors: boolean = true;
    @Output() downloadResultsAction = new EventEmitter();
    @Output() downloadRepresentationAction = new EventEmitter();
    @Output() downloadCerfaAction = new EventEmitter();
    @Output() teletransmission = new EventEmitter();
    @Output() goToAuditPageAction = new EventEmitter();
    @Output() missingAssessorsAction = new EventEmitter();
    @Output() relaunchAssessorsAction = new EventEmitter();
    constructor(private router: Router,
        private route: ActivatedRoute,
        public common: Common
    ) { }

    viewMissingAssessors() {
        this.missingAssessorsAction.emit();
    }

    relaunchAssessors() {
        this.relaunchAssessorsAction.emit();
    }

    goToAuditPage() {
        this.goToAuditPageAction.emit();
    }

    downloadResults() {
        this.downloadResultsAction.emit();
    }

    downloadRepresentation() {
      this.downloadRepresentationAction.emit();
    }

    downloadCerfa() {
      this.downloadCerfaAction.emit();
    }

    teletransmissionClick() {
      this.teletransmission.emit();
    }

    navigateHome() {
        this.router.navigate(['/polls']);
    }

    get requiredAssessors(): number {
        return Math.floor(this.assessorCount / 2) + 1;
    }

    ngOnInit(): void {

    }
}
